import { create } from 'zustand';
import { ChatState, Message } from '../types/chat';
import { chatService, messageService } from '../services/chat';
import { getBrowserLanguage, getRandomGreeting } from '../utils/languageUtils';
import { useAgentStore } from './agentStore';

export const useChatStore = create<ChatState>((set, get) => ({
  messages: [],
  isOpen: false, // Changed from true to false
  isLoading: false,
  awaitingFollowUp: false,
  followUpContext: undefined,
  hasShownGreeting: false,

  setIsOpen: (open) => set({ isOpen: open }),

  addMessage: (message) => {
    const newMessage = messageService.createMessage(message);
    set((state) => ({
      messages: [...state.messages, newMessage],
    }));
  },

  sendMessage: async (content: string) => {
    const store = get();
    store.addMessage({ content, sender: 'user' });
    
    set({ isLoading: true });
    
    try {
      const response = await chatService.sendMessage(content);
      store.addMessage(response);
    } finally {
      set({ isLoading: false });
    }
  },

  initializeChat: () => {
    const store = get();
    
    if (!store.hasShownGreeting && store.messages.length === 0) {
      const { currentAgent } = useAgentStore.getState();
      const language = getBrowserLanguage();
      
      const greeting = getRandomGreeting(language, currentAgent.id);
      
      store.addMessage({
        content: greeting,
        sender: 'assistant'
      });
      
      set({ hasShownGreeting: true });
    }
  },

  clearMessages: () => set({ messages: [], hasShownGreeting: false }),
  
  setHasShownGreeting: (value: boolean) => set({ hasShownGreeting: value })
}));

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    const chatStore = useChatStore.getState();
    chatStore.clearMessages();
  });
}